import { openBlock as t, createElementBlock as l, createStaticVNode as a } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, h = /* @__PURE__ */ a('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#338AF3" d="M20 0C12.07 0 5.22 4.614 1.984 11.304h36.03C34.78 4.614 27.93 0 20 0Zm0 40c7.93 0 14.78-4.614 18.015-11.304H1.985C5.218 35.386 12.07 40 20 40Z"></path><path fill="#FFDA44" d="M20 13.913a6.087 6.087 0 1 0 0 12.174 6.087 6.087 0 0 0 0-12.174Zm0 9.565a3.478 3.478 0 1 1 0-6.956 3.478 3.478 0 0 1 0 6.956Z"></path><path fill="#0052B4" d="M23.012 20.87 20 20l-3.013.87-1.004 1.739h8.033l-1.004-1.74Z"></path><path fill="#338AF3" d="m20 15.652-2.009 3.479L20 20l2.008-.87L20 15.652Z"></path><path fill="#6DA544" d="M16.987 20.87h6.025l-1.004-1.74H17.99l-1.004 1.74Z"></path>', 6), o = [
  h
];
function c(p, i) {
  return t(), l("svg", e, [...o]);
}
const d = { render: c };
export {
  d as default,
  c as render
};
